import { FilterSearch } from '../filter-search.model';

export class TenderListFilters {
  public static filterSearch: FilterSearch = {
    filter: null,
    filterSearchValue: '',
  };
}
